import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the sheet; each part uses its own slice of it */
import styles from './SMLCreationSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CreationSheetHeaderProps {
  onBack?: () => void;
  onClose: () => void;
}

const CreationSheetHeaderComponent: React.FC<CreationSheetHeaderProps> = ({ onBack, onClose }) => {
  const intl = useIntl();

  return (
    <div className={styles.head}>
      {onBack !== undefined && (
        <button
          type="button"
          className={styles.headButton}
          onClick={onBack}
          aria-label={intl.formatMessage({ id: 'app.sml.create.back', defaultMessage: 'Back' })}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
      )}
      <h2 className={styles.headTitle}>
        {intl.formatMessage({ id: 'app.sml.create.title', defaultMessage: 'New smartlink' })}
      </h2>
      <button
        type="button"
        className={styles.headButton}
        onClick={onClose}
        aria-label={intl.formatMessage({ id: 'app.sml.create.close', defaultMessage: 'Close' })}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export const CreationSheetHeader = TypedMemo(CreationSheetHeaderComponent);
